import { RendererService } from './../components/renderer.service';
import { SceneService } from './../components/scene.service';
import { Component, ElementRef } from '@angular/core';
import { VolumeModel } from '../model';
import { HelpersVolumeRendering } from './helpers/helpers.volumerendering';
import { EntityComponent } from '../components/share/entity-component';
import { Vector3 } from 'three';
import { HelperLut } from './helpers/helpers.lut';
import ModelsStack from './models/models.stack';
import ModelsFrame from './models/models.frame';
import { GrayImage3 } from '../../image-slice-show/share/image';

@Component({
  selector: 'ng3-volume-rendering',
  templateUrl: './volume-rendering.component.html',
  styleUrls: ['./volume-rendering.component.css'],
})
export class VolumeRenderingComponent extends EntityComponent<VolumeModel> {
  constructor(
    sceneService: SceneService,
    renderer: RendererService,
    ef: ElementRef,
  ) {
    super(sceneService, renderer);
    this.ef = ef.nativeElement;
    this.lut = new HelperLut(this.ef);
    this.lut.luts = HelperLut.presetLuts();
    this.lut.lutsO = HelperLut.presetLutsO();
    renderer.renderer.setClearColor(0xeeeeee);
  }

  createEntity(model: VolumeModel) {
    const stack = this.getStack(model.volume);
    const helper = new HelpersVolumeRendering(stack);
    this.lut.lut = model.color; // color
    this.lut.lutO = model.opacity; // opacity
    helper.uniforms.uTextureLUT.value.dispose();
    helper.uniforms.uTextureLUT.value = this.lut.texture;
    helper.uniforms.uLut.value = 1;
    helper.algorithm = model.algorithm; // algorithm
    helper.alphaCorrection = model.alphaCorrection; // alphaCorrection
    // helper.uniforms.uInterpolation.value = 1;
    return helper;
  }

  updateEntity(model: VolumeModel, entity: HelpersVolumeRendering) {
    const stack = this.getStack(model.volume);
    const helper = new HelpersVolumeRendering(stack);
    this.lut.lut = model.color; // color
    this.lut.lutO = model.opacity; // opacity
    helper.uniforms.uTextureLUT.value.dispose();
    helper.uniforms.uTextureLUT.value = this.lut.texture;
    helper.uniforms.uLut.value = 1;
    helper.algorithm = model.algorithm; // algorithm
    helper.alphaCorrection = model.alphaCorrection; // alphaCorrection
    // helper.uniforms.uInterpolation.value = 1;
    return helper;
  }

  getStack(volume: GrayImage3) {
    let stack = new ModelsStack();
    const rows = volume.meta.shape.x;
    const cols = volume.meta.shape.y;
    const frames = volume.meta.shape.z;
    stack._numberOfFrames = frames;
    stack.modality = 'unknown';
    for (let i = 1; i <= stack._numberOfFrames; i++) {
      let frame = new ModelsFrame();
      frame.sopInstanceUID = i;
      frame.index = i;
      frame.instanceNumber = i;
      frame.rows = rows;
      frame.columns = cols;
      frame.pixelSpacing = [1.0, 1.0, 1.0];
      frame.imagePosition = [127.0, 118.0, -57.0];
      // frame.imagePosition = [volume.meta.center.x, volume.meta.center.y, volume.meta.center.z];
      // frame.pixelData = this.getData(i, rows, cols);
      frame.pixelData = this.getFrame(i, volume);
      frame.imageOrientation = [-1, -0, 0, -0, -1, 0];
      frame.rescaleSlope = 1;
      frame.rescaleIntercept = 0;
      frame.minMax = this.getMinMax(frame.pixelData);
      if (frame.imageOrientation === null) {
        frame.imageOrientation = [1, 0, 0, 0, 1, 0];
      }
      stack.frame.push(frame);
      // console.log(frame.pixelData);
    }
    return stack;
  }
  getFrame(k: number, volume: GrayImage3): Uint8Array {
    let data = new Uint8Array(volume.meta.shape.x * volume.meta.shape.y);
    for (let i = 1; i <= data.length; i++) {
      data[i] = volume.pixel(i + k * volume.meta.shape.x * volume.meta.shape.y);
    }
    // for (let i = 1; i <= volume.meta.shape.x; i++) {
    //   for (let j = 1; j <= volume.meta.shape.y; j++) {
    //     data[i][j] = volume.pixel3(i, j, k);
    //   }
    // }
    return data;
  }
  getData(k: number, rows: number, columes: number): Uint8Array {
    let data = new Uint8Array(rows * columes);

    for (let i = 1; i <= data.length; i++) {
      data[i] = 0;
    }
    return data;
  }
  getMinMax(data: Uint8Array) {
    let min,
      max = 0;
    let sortData = data.sort();
    min = sortData[0];
    max = sortData[sortData.length - 1];
    return [min, max];
  }
  defaultModel(): VolumeModel {
    return new VolumeModel('red', 'bandpass', 0, 0.25, new GrayImage3(
      new Vector3(0, 0, 0),
      new Vector3(190, 256, 151),
      new Vector3(190, 256, 151),
      new Float32Array(190 * 256 * 151),
    ),);
  }
}
